var $c68c2e4fc74398d1$exports = {};
$c68c2e4fc74398d1$exports = {
    "dismiss": `Schlie\xdfen`
};


export {$c68c2e4fc74398d1$exports as default};
//# sourceMappingURL=de-DE.module.js.map
